/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import { useQuery } from '@tanstack/react-query';
import { auditService } from '../services';
import type { AuditQueryParams } from '../services';

export const AUDIT_LOG_KEY = 'audit-log';

export function useAuditLog(params: AuditQueryParams, enabled = true) {
  return useQuery({
    queryKey: [AUDIT_LOG_KEY, params],
    queryFn: () => auditService.query(params),
    enabled,
  });
}
